import { isFieldElement, LayoutElement } from "@entaconsulting/form";
import { get } from "lodash";
import monaco from "monaco-editor";
import store from "store";
import getObjectAtCursor from "./getObjectAtCursor";

const provideCompletionVariant = (
  model: monaco.editor.ITextModel,
  position: monaco.Position
): monaco.languages.ProviderResult<monaco.languages.CompletionList> => {
  const OPTIONS_VARIANT_SUGGESTIONS: string[] = [
    "options",
    "combobox",
    "select",
  ];
  const BOOLEAN_VARIANT_SUGGESTIONS: string[] = ["switch", "checkbox"];

  // find out if we are completing a property in the 'dependencies' object.
  const textUntilPosition: string = model.getValueInRange({
    startLineNumber: 1,
    startColumn: 1,
    endLineNumber: position.lineNumber,
    endColumn: position.column,
  });

  const match = textUntilPosition.match(/\t*"variant"\s*:\s*".*$/);

  if (!match) {
    return { suggestions: [] };
  }

  const currentObject: LayoutElement | null = getObjectAtCursor(
    model,
    position
  );

  if (!currentObject || !isFieldElement(currentObject)) {
    return { suggestions: [] };
  }

  const word: monaco.editor.IWordAtPosition =
    model.getWordUntilPosition(position);

  const range: monaco.IRange = {
    startLineNumber: position.lineNumber,
    endLineNumber: position.lineNumber,
    startColumn: word.startColumn,
    endColumn: word.endColumn,
  };

  const schemaObject =
    store.getState().developer.edit.editor.formDefinitionPreview.schema;
  const name = currentObject.name;

  const fieldDefinition = get(schemaObject, name);

  return {
    suggestions: ["select", "options"].includes(fieldDefinition.type)
      ? OPTIONS_VARIANT_SUGGESTIONS.map((suggestion) => {
          return {
            label: suggestion,
            insertText: `${suggestion}`,
            range,
            kind: 3, //Field
          };
        })
      : fieldDefinition.type === "boolean"
      ? BOOLEAN_VARIANT_SUGGESTIONS.map((suggestion) => {
          return {
            label: suggestion,
            insertText: `${suggestion}`,
            range,
            kind: 3, //Field
          };
        })
      : [],
  };
};

export default provideCompletionVariant;
